import {mapGetters, mapActions} from 'vuex';
import {assign} from "lodash";

export default {
  name: 'ordersCollecting',
  data() {
    return {}
  },
  components: {},
  created() {
    if (!('page' in this.$route.query)) {
      this.setUrlParams({page: 1});
    } else {
      this.fetchCollectingOrders(this.$route.query);
    }
  },
  mounted() {},
  computed: {
    ...mapGetters({
      ordersCollectingList: 'orders/ordersCollectingList',
      isOrdersCollectingLoading: 'orders/isOrdersCollectingLoading',
      ordersCollectingPage: 'orders/ordersCollectingPage',
      ordersCollectingPageLength: 'orders/ordersCollectingPageLength',
    }),
  },
  watch: {
    '$route.query': {
      handler: function (val) {
        if (val.page) {
          this.fetchCollectingOrders(this.$route.query);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      fetchCollectingOrders: 'orders/ORDERS_REQUEST_COLLECTING_LIST_GET',
    }),
    getClient(item) {
      return item.address
    },
    setUrlParams(query = {}) {
      this.$router.push({name: 'orders.list', query: assign({}, this.$route.query, query)}).catch(() => {
        console.log()
      });
    },
    getPage(pageId) {
      this.setUrlParams({page: pageId})
    },
    show(order) {
      this.$router.push({name: 'orders.show', params: {orderId: order.id}}).catch(() => {console.log();});
    }
  },
  destroyed() {},
}
